import { BehaviorSubject } from "rxjs";

import { fetchWrapper } from "data/FetchWrapper";
import { queryService, topicService } from "services";
import { history } from "data/History";

const user$ = new BehaviorSubject(JSON.parse(localStorage.getItem("user")));
const abort$ = new BehaviorSubject(new AbortController());
const baseUrl = `/api/user`;

export const accountService = {
  login,
  logout,
  register,
  verifyEmail,
  deleteEmail,
  forgotPassword,
  resetPassword,
  updatePassword,
  delete: _delete,
  profile,
  abort,
  user: user$,
  get userValue() {
    return user$.value;
  },
};

function login(email, password) {
  return fetchWrapper
    .post(`${baseUrl}/login`, { email, password }, abort$.value.signal)
    .then((user) => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      localStorage.setItem("user", JSON.stringify(user));

      // publish user to subscribers
      user$.next(user);

      return user;
    });
}

function logout() {
  // remove user from local storage and publish null to user subject
  localStorage.removeItem("user");
  if (user$.value != null) {
    fetchWrapper.post(`${baseUrl}/logout`, abort$.value.signal);
    queryService.query$.next(null);
    topicService.topics$.next([]);
    topicService.current$.next(null);
    topicService.queries$.next(null);
  }
  user$.next(null);
  history.push("/account/login");
}

function register(params) {
  return fetchWrapper.post(`${baseUrl}/register`, params, abort$.value.signal);
}

function verifyEmail(email, token) {
  return fetchWrapper.put(
    `${baseUrl}/confirm`,
    { email, token },
    abort$.value.signal
  );
}

function deleteEmail(email, token) {
  return fetchWrapper.delete(
    `${baseUrl}/confirm`,
    { email, token },
    abort$.value.signal
  );
}

function forgotPassword(email, redirectUrl) {
  return fetchWrapper.post(`${baseUrl}/forgot-password`, { email });
}

function resetPassword({ email, token, password, confirmPassword }) {
  return fetchWrapper.put(
    `${baseUrl}/reset-password`,
    {
      email,
      token,
      password,
      confirmPassword,
    },
    abort$.value.signal
  );
}

function updatePassword({ oldPassword, password, confirmPassword }) {
  return fetchWrapper.put(
    `${baseUrl}/update-password`,
    {
      oldPassword,
      password,
      confirmPassword,
    },
    abort$.value.signal
  );
}

function _delete() {
  return fetchWrapper
    .delete(`${baseUrl}/delete`, null, abort$.value.signal)
    .then(() => {
      queryService.query$.next(null);
      topicService.topics$.next([]);
      topicService.current$.next(null);
      topicService.queries$.next(null);
    });
}

function profile() {
  return fetchWrapper.get(`${baseUrl}/user-data`, abort$.value.signal);
}

function abort() {
  abort$.value.abort();
  abort$.next(new AbortController());
}
